export default __webpack_public_path__ + "static/media/nest.6dfbbfd8.gif";